import { useContext } from 'react';
import { Button } from 'reactstrap';

import { useNotesContext } from '../../../../contexts/NotesContext';
import { MapContext } from '../../../../contexts/MapContext';
import NotesHeaderContainer from './NotesHeaderContainer';
import useReadonly from '../../../../hooks/useReadonly';
import { captureEvent } from '../../../../utils/analytics';

const useOnNewNoteClick = () => {
  const { setCurrentNoteId } = useNotesContext();
  const {
    mapState: { hasDirtyNote, setConfirmNoteModalOpen },
  } = useContext(MapContext);

  return () => {
    captureEvent('note-click-new');
    if (hasDirtyNote) {
      setConfirmNoteModalOpen(true);
    } else {
      setCurrentNoteId(0);
    }
  };
};

const NotesHeader = ({ title }) => {
  const readonly = useReadonly();
  const onNewNoteClick = useOnNewNoteClick();

  return (
    <NotesHeaderContainer className="d-flex justify-content-between">
      <span>{title}</span>
      {!readonly && (
        <Button
          color="link"
          size="sm"
          className="fs-new-note-button p-0"
          onClick={onNewNoteClick}
        >
          + New Note
        </Button>
      )}
    </NotesHeaderContainer>
  );
};

export default NotesHeader;
